import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Col,
  Container,
  Row,
  Badge,
} from 'reactstrap';
import DataTable from '../../shared/components/DataTable';
import {
  filter,
  remove,
} from '../../redux/actions/periodoActions';
import Confirm from '../../shared/components/Confirm';
import { createErrorMessage, createSuccessMessage } from '../../helpers/notification';
import LoadingSpinner from '../../shared/components/LoadingSpinner';
import { dateFormat } from '../../helpers/dateFormat';

class PeriodosContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 25,
      totalItemsCount: 0,
      loading: true,
      items: [],
      filters: { id: 20 },
    };
    this.columns = [
      {
        key: 'anho',
        name: 'Año',
        search: false,
        width: '80px',
        format: ({ anho: value, activo }) => this.columnStyle({ value, activo }),
      },
      {
        key: 'nombre',
        name: 'Nombre',
        search: false,
        format: ({ nombre: value, activo }) => this.columnStyle({ value, activo }),
      },
      {
        key: 'inicioClases',
        name: 'Inicio de clases',
        search: false,
        type: 'date',
        format: ({ inicioClases, activo }) => this.columnStyle({ value: dateFormat(inicioClases), activo }),
      },
      {
        key: 'finClases',
        name: 'Fin de clases',
        search: false,
        type: 'date',
        format: ({ finClases, activo }) => this.columnStyle({ value: dateFormat(finClases), activo }),
      },
      {
        key: 'inicioPeriodoInscripcion',
        name: 'Inicio de inscripciones',
        search: false,
        type: 'date',
        format: ({ inicioPeriodoInscripcion, activo }) => this.columnStyle({
          value: dateFormat(inicioPeriodoInscripcion),
          activo,
        }),
      },
      {
        key: 'finPeriodoInscripcion',
        name: 'Fin de inscripciones',
        search: false,
        type: 'date',
        format: ({ finPeriodoInscripcion, activo }) => this.columnStyle({
          value: dateFormat(finPeriodoInscripcion),
          activo,
        }),
      },
      {
        key: 'finCalificarTareas',
        name: 'Límite para calificar tareas',
        search: false,
        type: 'date',
        format: ({ finCalificarTareas, activo }) => this.columnStyle({ value: dateFormat(finCalificarTareas), activo }),
      },
      {
        key: 'finEditarPlaneamiento',
        name: 'Límite para editar planeamiento',
        search: false,
        type: 'date',
        format: ({
          finEditarPlaneamiento, activo,
        }) => this.columnStyle({
          value: dateFormat(finEditarPlaneamiento),
          activo,
        }),
      },
      {
        key: 'esSemestrePar',
        name: 'Es semestre par',
        search: false,
        format: ({ esSemestrePar, activo }) => this.columnStyle({ value: (esSemestrePar ? 'Si' : 'No'), activo }),
      },
      {
        key: 'activo',
        name: 'Activo',
        search: false,
        format: ({ activo }) => this.columnStyle({ value: (activo ? 'Si' : 'No'), activo }),
      },
      { key: 'actions', name: 'Accion', width: '85px' },
    ];
    this.actions = [
      {
        key: 'edit',
        icon: <span className="fa fa-edit" title="Editar periodo" />,
        callback: (periodo) => {
          this.editPeriodo(periodo);
        },
      },
      {
        key: 'delete',
        icon: <span className="fa fa-trash" title="Borrar periodo" />,
        callback: (periodo) => {
          this.handleDeletePeriodo(periodo);
        },
      },
    ];
  }

  componentDidMount() {
    const { page, pageSize } = this.state;
    this.updatePeriodosTable(page, pageSize);
  }

  updatePeriodosTable = (page, pageSize, filters) => {
    this.setState({
      loading: true,
      page,
      pageSize,
      filters: filters || {},
    });
    filter({
      pageInfo: {
        page,
        pageSize,
        filters,
      },
      onSuccess: (pageInfo) => {
        this.setState({
          loading: false,
          items: pageInfo.items,
          totalItemsCount: pageInfo.totalItemsCount,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de periodos');
      },
    });
  }

  handleDeletePeriodo = (periodo) => {
    const name = `${periodo.materia.codigo}- ${periodo.materia.nombre}`;
    Confirm({
      title: 'Borrar periodo',
      question: `Estás seguro que deseas eliminar el periodo ${name}?`,
      yesLabel: 'Si, Borrar periodo',
      noLabel: 'No, Volver',
      onConfirm: () => {
        remove(periodo.id,
          {
            onSuccess: () => {
              createSuccessMessage('Periodo borrado exitosamente');
              const { page, pageSize } = this.state;
              this.updatePeriodosTable(page, pageSize);
            },
            onError: (error) => {
              if (error && error.status === 404) {
                createErrorMessage('El periodo no existe');
              } else {
                createErrorMessage('Error al intentar borrar el periodo');
              }
            },
          });
      },
    });
  };

  editPeriodo = (periodo) => {
    const { history } = this.props;
    history.push(`/pages/periodos/edit/${periodo.id}`);
  };

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updatePeriodosTable(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updatePeriodosTable(1, pageSize, values);
    }
  };


  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updatePeriodosTable(1, pageSize, {});
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  columnStyle = ({ activo, value }) => {
    if (!activo) {
      return value;
    }

    return (
      <Badge
        style={{ fontSize: '13px' }}
        color="primary"
        pill
      >
        {value}
      </Badge>
    );
  }

  render() {
    const {
      loading,
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Lista de periodos</h3>
            <div className="card__title">
              <Link className="btn btn-primary" to="/pages/periodos/new">
                <i className="fa fa-plus" /> Agregar nuevo periodo
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          {loading ? <LoadingSpinner />
            : (
              <DataTable
                title="Listado de todos los periodos"
                columns={this.columns}
                items={items}
                onChangePage={this.onChangePage}
                page={page}
                pageSize={pageSize}
                totalItemsCount={totalItemsCount}
                getGridActions={key => this.getGridActions(key)}
                onSubmit={this.onDataTableSubmit}
                onClearFilters={this.onDataTableClearFilters}
                initialValues={filters}
                enableReinitialize
              />
            )
          }
        </Row>
      </Container>
    );
  }
}

export default withRouter(PeriodosContainer);
